import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState, } from 'react';
import cn from 'classnames';
import noop from 'lodash-es/noop';
import { useOnWindowResize } from 'rooks';
import { DropdownField } from './DropdownField';
import { DropdownMenu } from './DropdownMenu';
import { useDropdown } from './hooks';
export const Dropdown = ({ className, fieldClassName, id, itemClassName, items, menuClassName, onChange, openTitle, clearTitle, closeTitle, initialMenuOpen = false, onClear, onClose = noop, onOpen = noop, disabled = false, isSearchable = false, value, ...rest }) => {
    const fallbackId = `dropdown${useId()}`;
    const [isMenuOpen, setMenuOpen] = useState(initialMenuOpen);
    const [menuWidth, setMenuWidth] = useState();
    const fieldRef = useRef(null);
    const { inputRef, onItemClick, onMenuChange, selectedItem, selectedItemRef, selectedLabelOrSearchString, onChangeSearch, onClearSearchOrSelected, filteredItems, } = useDropdown({
        items,
        isMenuOpen,
        disabled,
        setMenuOpen,
        onClearSelected: onClear,
        onClose,
        onOpen,
        onChange,
        isSearchable,
        value,
    });
    useEffect(() => {
        setMenuWidth(fieldRef.current?.clientWidth);
    }, [isMenuOpen]);
    useOnWindowResize(() => {
        setMenuWidth(fieldRef.current?.clientWidth);
    }, isMenuOpen);
    return (_jsx("div", { className: cn('dropdown-root', 'u-typography-body', className), "data-testid": rest['data-testid'] && `${rest['data-testid']}-container`, children: _jsx(DropdownMenu, { anchor: _jsx(DropdownField, { ...rest, className: fieldClassName, clearTitle: clearTitle, closeTitle: closeTitle, id: id || fallbackId, inputRef: inputRef, disabled: disabled, onChange: onChangeSearch, onClear: onClearSearchOrSelected, openTitle: openTitle, readOnly: !isSearchable, ref: fieldRef, selectedItemPrefix: selectedItem?.prefix, value: selectedLabelOrSearchString }), className: menuClassName, disabled: disabled, fieldId: id || fallbackId, itemClassName: itemClassName, open: isMenuOpen && !disabled, onToggle: onMenuChange, items: filteredItems, isSearchable: isSearchable, role: "combobox", selectedValue: selectedItem?.value, selectedItemRef: selectedItemRef, style: { width: menuWidth }, onItemClick: onItemClick }) }));
};
//# sourceMappingURL=Dropdown.js.map